<header>
  <nav class="d-flex justify-content-between">
    <div class="nav-left d-flex align-items-center">
      <img
        class="button-navBar"
        (click)="goToHome()"
        src="/assets/img/navBar_logo.svg"
        alt=""
      />
      <div class="greeting-container" *ngIf="userName">
        <span class="greeting-text">¡Hola {{userName}}!</span>
        <span class="greeting-icon">👋</span>
      </div>
    </div>
    <ng-container *ngIf="!isBeneficiariesFormRoute" >
      <div class="nav-menu-mobile">
        <button><i class="fa-solid fa-magnifying-glass"></i></button>
        <button><i class="fa-regular fa-bell"></i></button>
        <button><i class="fa-solid fa-bars"></i></button>
      </div>
      <ul class="nav-menu d-flex">
        <li class="nav-menu-item">
          <a id="linkContratoColectivo" class="copec-rg-16" href="{{this.basePath}}" target="_blank" rel="noopener">Contrato Colectivo</a>
        </li>
        <li class="nav-menu-item">
          <a id="linkBrochureBeneficios" class="copec-rg-16" href="{{this.brochurePath}}" target="_blank" rel="noopener">Nuestros Beneficios</a>
        </li>
        <li class="nav-menu-item" *ngIf="usuarioVigente">
          <a class="copec-rg-16" (click)="goToPlan()">Planes</a>
        </li>
        <li class="nav-menu-item">
          <a class="copec-rg-16" *ngIf="isPracticing===false" (click)="goToRequests()">Mis solicitudes</a>
        </li>
        <li class="nav-menu-item m-0">
          <button class="icon-user" [matMenuTriggerFor]="menu" aria-label="menu">
            <mat-icon fontIcon="account_circle"></mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button *ngIf="isAdmin || superAdmin" (click)="goToAdmin()" mat-menu-item>
              <mat-icon>person</mat-icon>
              <span>Administrador</span>
            </button>
            <button (click)="cerrarSesion()" mat-menu-item>
              <mat-icon>logout</mat-icon>
              <span>Cerrar Sesión</span>
            </button>
          </mat-menu>
        </li>
      </ul>
    </ng-container>
    <div *ngIf="isBeneficiariesFormRoute">
      <button mat-stroked-button class="button-save copec-rg-14" (click)="goToHome()">Guardar y salir</button>
    </div>
  </nav>
</header>
